module.exports = function* enumerate (arr) {
  let i = 0

  for (const x of arr) {
    yield [i, x]
    i++
  }
}
